import Vue from 'vue'
import VueRouter from 'vue-router'
import Step1 from '@/pages/Step1.vue'
import Step2 from '@/pages/Step2.vue'
import Step2_KB from '@/pages/Step2_KB.vue'
import Step3 from '@/pages/Step3.vue'
import Step4 from '@/pages/Step4.vue'

Vue.use(VueRouter)

export default new VueRouter({
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Step1-Base',
      component: Step1
    },
    {
      path: '/step1',
      name: 'Step1',
      component: Step1
    },
    {
      path: '/step2',
      name: 'Step2',
      component: Step2
    },
    {
      path: '/step2_KB',
      name: 'Step2_KB',
      component: Step2_KB
    },
    {
      path: '/step3',
      name: 'Step3',
      component: Step3
    },
    {
      path: '/step4',
      name: 'Step4',
      component: Step4
    },
    {
      path: '/amex/:customerId',
      name: 'amex',
      component: Step3
    }
  ]
})
